<template>
  <div class="order-summary-item">    

    <table class="table">
      <thead>
        <tr>
          <th class="pb-0" colspan="3"><label class="mb-0 activation-badge d-block badge badge-primary" v-if="item.iccid != ''">Activation</label></th>
        </tr>
        <tr>
          <th colspan="2"><a class="badge badge-primary">{{ item.id }}</a> {{ dealName + " - " + subscriberName }}</th>
          <th class="remove"><a class="badge badge-primary" @click="toggle_block=true">REMOVE <span class="fa fa-trash"></span></a></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="details" v-html="dealDescription"></td>          
          <td class="value"></td>
          <td class="value">{{ (item.deal.price > 0 ? item.deal.price  : 'FREE') | currency }}</td>
        </tr>
        <tr class="extras" v-if="item.subscriber.port_number">
          <td class="details" colspan="3">Port Number: {{ item.subscriber.number_to_port }}</td>
        </tr>
        <tr v-if="hasExtras">
          <td class="extras-separator" colspan="3">Added Extra's</td>
        </tr>
        <tr class="extras" v-if="!isEmpty(item.data)">
          <td class="details">{{ item.data.name }} DATA</td>          
          <td class="value"></td>
          <td class="value">{{ item.data.price | currency }}</td>
        </tr>
        <tr class="extras" v-if="!isEmpty(item.mins)">
          <td class="details">{{ item.mins.name }} MINS</td>          
          <td class="value"></td>
          <td class="value">{{ item.mins.price | currency }}</td>
        </tr>
        <tr class="extras" v-if="!isEmpty(item.sms)">
          <td class="details">{{ item.sms.name }} SMS'S</td>          
          <td class="value"></td>
          <td class="value">{{ item.sms.price | currency  }}</td>
        </tr>
        <tr class="extras" v-if="!isEmpty(item.whatsApp)">
          <td class="details">{{ item.whatsApp.name }} WHATSAPP</td>          
          <td class="value"></td>
          <td class="value">{{ item.whatsApp.price | currency  }}</td>
        </tr>
        <tr class="extras">
          <td class="details">CONNECTION FEE</td>
          <td class="value">{{ connectionFee | currency }}</td>
          <td class="value"></td>          
        </tr>
      </tbody>
    </table>
    <vue-block :classname="'align-items-center justify-content-center'" :toggle.sync="toggle_block">
      <div class="remove-container">
        <h4>Remove from order?</h4>   
        <div>
          <button class="btn btn-outline-light btn-sm" @click="removeItem(item)">Yes</button>
          <button class="btn btn-outline-light btn-sm" @click="toggle_block = !toggle_block">No</button>
        </div>     
      </div>
    </vue-block>
  </div>
</template>

<script>
import store from "@/store";
import {
  CART_REMOVE_ITEM
} from "@/store/actions.type";

export default {
  name: "order-summary-item",
  props: ["item", "connectionFee"],
  data() {
    return {
      toggle_block: false
    };
  },
  computed: {
    dealName() {
      return this.item.deal.display_details.name;
    },
    dealDescription() {
      return this.item.deal.display_details.description;
    },
    subscriberName() {
      var self = this;
      return (
        self.item.subscriber.first_name + " " + self.item.subscriber.last_name
      );
    },
    hasExtras() {
      var self = this;
      return !self.isEmpty(self.item.data) || 
            !self.isEmpty(self.item.mins) ||
            !self.isEmpty(self.item.sms) ||
            !self.isEmpty(self.item.whatsApp);
    }
  },
  methods: {
    isEmpty: function(data) {
      return data == null || typeof (data) == 'undefined' || Object.keys(data).length === 0;
    },
    removeItem: function(item) {
      var self = this;
      self.$log.debug("remove item", item.id);
      store.dispatch(CART_REMOVE_ITEM, item);
    }
  }
};
</script>